import apiService from "./apiService";

const logService = {
    async search(searchModel){
        try{
            const resp =await apiService.get(`logs/search-audit-logs`,searchModel,true);
            return resp.data;
        }
        catch{
            return {};
        }
    }
}

export default logService;